import moment from 'moment';
import { i18n, locale } from '@/plugins/i18n';

const formatDateAsString = (dateAsString: string | undefined, format?: string) => {
    return moment(dateAsString).format(format || 'LLLL');
};

export const startOfUtcDay = (value: Date | string): Date => {
    const date = new Date(value);
    date.setUTCHours(0, 0, 0, 0);
    return date;
};

export const endOfUtcDay = (value: Date | string): Date => {
    const date = new Date(value);
    date.setUTCHours(23, 59, 59, 999);
    return date;
};

export const normalizeUtcDateRange = (
    firstDate: Date | string,
    secondDate: Date | string,
): [Date, Date] => {
    const firstDay = startOfUtcDay(firstDate);
    const secondDay = endOfUtcDay(secondDate);

    return firstDay <= secondDay
        ? [firstDay, secondDay]
        : [startOfUtcDay(secondDate), endOfUtcDay(firstDate)];
};

// Format date relative to now (AURA chat timestamps)
export const formatRelativeDate = (dateString: string): string => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const t = i18n.global.t.bind(i18n);

    if (diff < 60000) return t('core.datetime.now');
    if (diff < 3600000) return `${Math.floor(diff / 60000)}${t('core.datetime.minutes')}`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}${t('core.datetime.hours')}`;
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
};

// Format short date for filter badges (DD/MM)
export const formatShortDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', timeZone: 'UTC' });
};

const formatSecToTime = (seconds: number, forceHours?: boolean): string => {
    let secs = Math.floor(seconds);
    let minutes = Math.floor(secs / 60);
    const hours = Math.floor(minutes / 60);

    secs %= 60;
    minutes %= 60;

    let strHours = '';
    if (hours || forceHours) {
        if (hours < 10) {
            strHours = `${'0' + hours}:`;
        } else {
            strHours = `${hours}:`;
        }
    }

    return `${strHours}${('0' + minutes).slice(-2)}:${('0' + secs).slice(-2)}`;
};

export { moment, formatDateAsString, formatSecToTime };

export default moment;
